import { render, staticRenderFns } from "./xcxSchemeData.vue?vue&type=template&id=629806d7&scoped=true"
import script from "./xcxSchemeData.vue?vue&type=script&lang=js"
export * from "./xcxSchemeData.vue?vue&type=script&lang=js"
import style0 from "./xcxSchemeData.vue?vue&type=style&index=0&id=629806d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629806d7",
  null
  
)

export default component.exports